<template>
    <el-main class="app_border">
        <el-row>
            <el-col :offset="3" :xs="24" :sm="24" :md="18" :lg="18" :xl="24">


        <el-form ref="form" :model="form" :rules="rules" label-width="80px" v-loading="loading" :disabled="hasdone">
            <el-form-item label="应用名称" prop="name">
                <el-input v-model="form.name" placeholder="请输入应用名称，不超过30个字"></el-input>
            </el-form-item>
            <el-form-item label="应用类型" prop="region">
                <el-select v-model="form.region" placeholder="请选应用类型">
                    <el-option label="插件" value="1"></el-option>
                    <el-option label="模板" value="2"></el-option>
                    <el-option label="扩展" value="3"></el-option>
                    <el-option label="程序" value="4"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item
                    label="应用价格"
                    prop="price"

                    >

                <el-input style="width:10rem" type="price" v-model.number="form.price" auto-complete="off"></el-input>
                <span>元</span>
            </el-form-item>

            <el-form-item label="应用描述" prop="desc" class="txt_appdesc">
                <div id="editorElem" style="text-align:left" ></div>

            </el-form-item>
            <el-form-item label="应用图片" prop="files">
            <el-upload
                    class="upload-demo"
                    ref="upload"
                    :action="this.$store.state.baseurl + 'appstore/receivefile'"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :on-exceed="handlenums"
                    :file-list="fileList"
                    :on-success="uploadsuccess"
                    :on-error="uploaderror"
                    :multiple="true"
                    accept=".jpg, .png"
                    :limit="5"
                    :auto-upload="false">
                <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb，最多5张图片</div>
            </el-upload>
        </el-form-item>
            <el-form-item label="说明文档" >
                <el-upload
                        class="upload-demo"
                        ref="uploaddoc"
                        :action="this.$store.state.baseurl + 'appstore/receivedocfile'"
                        :on-preview="handlePreviewDoc"
                        :on-remove="handleRemoveDoc"
                        :on-exceed="handlenumsDoc"
                        :file-list="docfileList"
                        :on-success="uploadsuccessDoc"
                        :on-error="uploaderrorDoc"
                        :multiple="true"
                        accept=".doc, .docx"
                        :limit="4"
                        :auto-upload="false">
                    <el-button slot="trigger" size="small" type="primary">选取文档</el-button>
                    <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUploadDoc">上传到服务器</el-button>
                    <div slot="tip" class="el-upload__tip">非必传，只能上传doc,docx文件，且不超过500kb，最多4个文档</div>
                </el-upload>
            </el-form-item>

            <el-form-item>
                <el-popover
                        ref="popover5"
                        placement="top"
                        width="160"
                        v-model="visible2">
                    <p>确定取消提交吗，取消后内容会清空？</p>
                    <div style="text-align: right; margin: 0">
                        <el-button size="mini" type="text" @click="visible2 = false">取消</el-button>
                        <el-button type="primary" size="mini" @click="goindex">确定</el-button>
                    </div>
                </el-popover>
                <el-button type="primary" @click="submitForm('form')">立即创建</el-button>
                <el-button  v-popover:popover5>取消</el-button>
            </el-form-item>
        </el-form>
            </el-col>
        </el-row>
        </el-main>
</template>
        <script>
            import E from 'wangeditor'
            import axios from 'axios'
            export default{
                name: 'addapplication',
                        data(){
                    return {

                        loading: false,
                        fileList: [],
                        docfileList: [],
                        visible2: false,
                        hasdone: false,
                        form: {
                            files:[],
                            docfiles:[],
                            name: '',
                            region: '',
                            price:0,
                            desc: '',
                            imgsrc:'',
                            accesstoken:this.$store.state.accesstoken
                        },
                        rules: {
                            name: [
                                { required: true, message: '请输入应用名称', trigger: 'blur' },
                                { min: 3, max: 30, message: '长度在 3 到 30 个字符', trigger: 'blur' }
                            ],
                            price: [
                                { required: true, message: '请输入应用价格', trigger: 'blur' },
                                {  type: 'number', message: '价格必须为数字值', trigger: 'blur' }
                            ],
                            region: [
                                { required: true, message: '请选择应用类型', trigger: 'change' }
                            ],

                            desc: [
                                { required: true, message: '请填写应用描述', trigger: 'blur' }
                            ],
                            files: [
                                { required: true, message: '请上传应用图片', trigger: 'blur' }
                            ]
                        }
                    }
                },
                mounted:function(){
                    if(!this.$store.state.loginstate){
                        this.$store.state.showloginform = true
                    }
                    var editor = new E('#editorElem')
                    editor.customConfig.onchange = (html) => {
                        this.form.desc = html
                    }
                    // 自定义菜单配置
                   /* editor.customConfig.menus = [
                        'head',
                        'bold',
                        'italic',
                        'underline'
                    ]*/
                    editor.create()
                },
                methods: {
                    submitUpload() {
                        this.$refs.upload.submit();
                    },
                    submitUploadDoc() {
                        this.$refs.uploaddoc.submit();
                    },
                    handleRemove(file, fileList) {
                        var _this = this;
                        _this.form.files.forEach(function(val,index){
                                   if(val==file.response){
                                       _this.form.files.splice(index,1)
                                       return
                                   }

                                })


                    },
                    handlePreview(file) {

                    },
                    handlenums(file,fileList){
                        this.$message('最多上传5张图片')
                    },
                    uploadsuccess(response, file, fileList){
                        if(response.match('error')){

                            this.$message(response.replace('error|',''))
                            return false
                        }
                        this.form.files.push(response)


                    },
                    uploaderror(err, file, fileList){
                        this.$message('上传图片出错')

                    },
                    handleRemoveDoc(file, fileList) {
                        var _this = this;
                        _this.form.docfiles.forEach(function(val,index){
                            if(val==file.response){
                                _this.form.docfiles.splice(index,1)
                                return
                            }

                        })


                    },
                    handlePreviewDoc(file) {

                    },
                    handlenumsDoc(file,fileList){
                        this.$message('最多上传4个文件')
                    },
                    uploadsuccessDoc(response, file, fileList){

                        if(response.match('error')){

                            this.$message(response.replace('error|',''))
                            return false
                        }
                        this.form.docfiles.push(response)


                    },
                    uploaderrorDoc(err, file, fileList){
                        this.$message('上传文件出错')

                    },
                    submitForm(formName) {
                        if(!this.$store.state.loginstate){
                            this.$store.state.showloginform = true
                            return false
                        }
                        this.$refs[formName].validate((valid) => {
                            if (valid) {
                            if(this.form.files.length<=0){
                                this.$message('请上传应用图片');
                                return false;
                            }

                           this.post()

                        } else {

                            return false;
                        }
                    });
                },
                post: function (){
                   // this.loading = true

                    var _this = this;
                    // 设置一个开关来避免重负请求数据
                    var sw = true;
                     _this.form.accesstoken=this.$store.state.accesstoken
                    var params = 'ajax='+encodeURIComponent(JSON.stringify(_this.form));
                    axios.post(this.$store.state.baseurl + 'appstore/receivepostappinfo',params).then(function (response) {
                                if(response.data.match('ok')){
                                    _this.hasdone = true
                                    _this.$message(response.data.replace('ok|',''));
                                    setTimeout(function(){
                                        _this.$router.push({name:'Index',params:{}})
                                    },2000)
                                }else{
                                    _this.$message(response.data.replace('error|',''));
                                }

                        _this.loading = false


                    }).catch(function (error) {
                        _this.$message(error);
                    });

                },
                    goindex(){
                        this.$router.push({name:'Index',params:{}})
                    }
                }
            }
        </script>


// WEBPACK FOOTER //
// src/components/AddApplication.vue